import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { NotificationsAction } from "../actions";

import * as fromNotifications from "./notifications.reducers";

// this is the type for our teacher-classes.module
// this creates the structure for our state tree
export interface NotificationsState {
    notifications: fromNotifications.NotificationsListState;
}

// register the reducer
// Since we are not using this Store anywhere now, I'm adding NotificationsAction to satisfy the strictFunctionType error
// however if we are using this notifications store in the future, we should remove it, and update the proper NGRX createAction
export const reducers: ActionReducerMap<NotificationsState, NotificationsAction> = {
    notifications: fromNotifications.reducer
};

// Creates the base level of our state object
export const getNotificationsModuleState = createFeatureSelector<
    NotificationsState
>("notificationsModule");
